import AccountingPlanBody from './AccountingPlanBody'
const AccountingPlan = () => {
  // const [accountingPlan, setAccountingPlan] = useState([])

  // const onGetAccountingPlan = async (): Promise<void> => {
  //   let response = await axios.get(`${server}/accounting?childrenOf=1`)
  //   console.log('response...', response)
  //   // setAccountingPlan(response.data)
  // }

  // useEffect(() => {
  //   onGetAccountingPlan()
  // }, [])

  let columnsTabs = [
    { name: 'Cod.', width: '7%' },
    { name: 'Nivel', width: '10%' },
    { name: 'Descripción', width: '40%' },
    { name: '', width: '7%' },
    { name: 'Balance', width: '10%' },
  ]

  return (
    <div style={{position: 'relative'}}>
      <div className="flex justify-between">
        {columnsTabs.map((column) => (
          <div style={{ width: column.width }}>
            <h1 className="text-sm font-semibold">{column.name}</h1>
          </div>
        ))}
      </div>

      <div className="h-px dark:bg-primaryGray-600 bg-primaryGray-700 col-span-12 my-3"></div>

      <AccountingPlanBody columns={columnsTabs} childrenOf={"1"} />
      {/* <h1 style={{position: 'absolute', bottom: 0}}>Hola</h1> */}
    </div>
  )
}

export default AccountingPlan

/**
 * activos
pasivos
patrimonio
ingresos
costos
gastos
 */
